import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { networkErrorInterceptor } from './core/interceptors/http-error/http-error.interceptor';
import { accessTokenHandlerInterceptor } from './core/interceptors/token/token.interceptor';
import { urlInterceptor } from './core/interceptors/url/url-interceptor.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    { provide: MAT_DATE_LOCALE, useValue: 'uk-UA' },
    provideHttpClient(withInterceptors([urlInterceptor, accessTokenHandlerInterceptor, networkErrorInterceptor])),
  ],
};
